import React, { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { addPaymentType } from "../../../../../api/apiServices";
import toast, { Toaster } from 'react-hot-toast'

const AddPaymentType = () => {

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/payment_types";


	const [type_code, setTypeCode] = useState("");
	const [description, setDescription] = useState("");
	const queryClient = useQueryClient();


	const addPaymentTypeMutation = useMutation(addPaymentType, {
		onSuccess: async (res) => {
			// Invalidate cached data
			toast.success(res.message, {
				duration: 5000,
				className: "toast-message",
			})
			setDescription("")
			queryClient.invalidateQueries("payment_types")
			navigate(from, { replace: true });
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			})
		}
	})

	const handleTypeChange = (e) => {
		const type = e.target.value
		const typeValue = type.replaceAll(" ", "_")
		setDescription(type)
		if (typeValue === "Mandatory_Payment") setTypeCode("MP")
		if (typeValue === "Special_Levy") setTypeCode("SL")
		if (typeValue === "Donation") setTypeCode("DN")
		if (typeValue === "Voluntary_Contribution") setTypeCode("VC")
		if (typeValue === "Funeral_Donation") setTypeCode("FD")
	}

	const handleSubmit = (e) => {
		e.preventDefault()

		const dataValues = {
			type_code: type_code.toLocaleUpperCase(),
			description: description.toLocaleUpperCase(),
		}
		addPaymentTypeMutation.mutate(dataValues)
	}

	const handleCancel = () => {
		navigate(from, { replace: true });
	}

	const content = (
		<>
			<div className="panel panel-default panel-br-4">
				<div className="panel-heading">
					<div className="row">
						<div className="col-sm-9">
							<h4 className="panel-title">
								<i className="fa fa-file-text" aria-hidden="true"></i>
								<span> PAYMENT TYPE SETUP</span>
							</h4>
						</div>
					</div>
				</div>
				<form onSubmit={handleSubmit}>
					<div className="panel-body">
						<div className="form-group row">
							<label htmlFor="type_code" className="col-sm-2 col-form-label">
								Payment Type
							</label>
							<div className="col-sm-6">
								<input
									type="text"
									id="type_code"
									placeholder="Payment type"
									autoComplete="off"
									style={{ textTransform: "uppercase" }}
									value={description}
									onChange={handleTypeChange}
									required
									name="type_code"
									className="form-control"
								/>
							</div>
						</div>
						<div className="panel-footer">
							<div className="form-group row">
								<div className="col-sm-1">
									<button type="submit" className="btn btn-danger" onClick={handleCancel}>
										Cancel
									</button>
								</div>
								<div className="col-sm-1">
									<button type="submit" className="btn btn-success">
										Submit
									</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</>
	)

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Add Payment Type</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{content}
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>

	)
}

export default AddPaymentType